import { api } from '../configs/apiConfig';

const BASE_URL = '/userpanelpreference';

const userPanelPreferenceService = {
    // Get a specific panel preference
    getPanelPreference: async (userId, desktopId, panelId) => {
        const response = await api.get(`${BASE_URL}/user/${userId}/desktop/${desktopId}/panel/${panelId}`);
        return response.data;
    },

    // Get all panel preferences for a desktop
    getDesktopLayout: async (userId, desktopId) => {
        const response = await api.get(`${BASE_URL}/user/${userId}/desktop/${desktopId}/layout`);
        return response.data;
    },

    // Create a new panel preference
    createPanelPreference: async (userId, preferenceData) => {
        const response = await api.post(`${BASE_URL}/user/${userId}`, preferenceData);
        return response.data;
    },

    // Update an existing panel preference
    updatePanelPreference: async (userId, desktopId, panelId, preferenceData) => {
        const response = await api.put(`${BASE_URL}/user/${userId}/desktop/${desktopId}/panel/${panelId}`, preferenceData);
        return response.data;
    },

    // Delete a panel preference
    deletePanelPreference: async (userId, desktopId, panelId) => {
        await api.delete(`${BASE_URL}/user/${userId}/desktop/${desktopId}/panel/${panelId}`);
        return true;
    },

    // Save the entire desktop layout
    saveDesktopLayout: async (userId, layoutDto) => {
        const response = await api.post(`${BASE_URL}/user/${userId}/desktop/layout`, layoutDto);
        return response.data;
    }
};

export default userPanelPreferenceService; 